import React from 'react';
import Lottie from 'lottie-react';
import loaderLottie from '../../../loaderlottie.json';
import { LOADER_STYLE } from '../constants';

const Loader = () => {
  return (
    <div style={LOADER_STYLE}>
      <Lottie
        animationData={loaderLottie}
        loop={true}
        style={{ height: '230px', width: '230px' }}
      />
    </div>
  );
};

export default Loader;
